exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contractCreator {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  grid-template-rows: auto;\n  grid-gap: 2rem;\n}\n.contractCreator .full-row {\n  grid-column: 1/span 3;\n}\n.contractCreator .grid-col-1 {\n  grid-column: 1;\n}\n.contractCreator .grid-col-2 {\n  grid-column: 2;\n}\n.contractCreator .grid-col-3 {\n  grid-column: 3;\n}\n.contractCreator .dropdown {\n  min-width: 250px;\n}", ""]);

// exports
